export default __webpack_public_path__ + "static/leaf 1-0502558e84466644b95f12694e4c2400.png";